import { Link } from "react-router-dom";
import React, { useState} from "react";
import { Accordion, Card } from "react-bootstrap";

export default function MenulistAcademics({setIsOpen}) {
  const handleLinkClick = () => {
        setIsOpen(false); 
  };

  const [activeKey, setActiveKey] = useState("null");
    
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key); 
  };

  return (
    <>
      <Accordion activeKey={activeKey} className="menuinner-accord">
        <Card className={activeKey === "0" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="0">
              <Accordion.Header as="h4" onClick={() => handleToggle("0")}>
                About LPS
                <span>{activeKey === "0" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>            
                  <li><Link to={"/lps-school-sector-i/manager-desk"} onClick={handleLinkClick}>Welcome From The Manager</Link></li>
                  <li><Link to={"/lps-school-sector-i/principal-desk"} onClick={handleLinkClick}>Welcome From The Principal</Link></li>
                  <li><Link to={"/lps-school-sector-i/teaching-staff"} onClick={handleLinkClick}>Teaching Staff</Link></li>
                  {/* <li><Link to={"/our-aim"} onClick={handleLinkClick}>Our Aim</Link></li>
                  <li><Link to={"/our-heritage"} onClick={handleLinkClick}>Our Heritage</Link></li>
                  <li><Link to={"/accreditation-and-affiliation"} onClick={handleLinkClick}>Accreditation & Affiliation</Link></li>
                  <li><Link to={"/why-lps-lucknow-public-school"} onClick={handleLinkClick}>Why LPS</Link></li> */}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>

        <Card className={activeKey === "1" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="1">
              <Accordion.Header as="h4" onClick={() => handleToggle("1")}>
                Admission
                <span>{activeKey === "1" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li><Link to={"/lps-school-sector-i/admission-process"} onClick={handleLinkClick}>admission process</Link></li>
                  <li><Link to={"/lps-school-sector-i/fee-structure"} onClick={handleLinkClick}>fee Structure</Link></li>
                  <li><Link to={"/lps-school-sector-i/book-list"} onClick={handleLinkClick}>Book List</Link></li>
                  <li><Link to={"/lps-school-sector-i/bursaries-and-scholarship"} onClick={handleLinkClick}>Bursaries & Scholarships</Link></li>
                  <li><Link to={"/lps-school-sector-i/schedule-a-visit"} onClick={handleLinkClick}>Schedule a Visit</Link></li>
                  <li><Link to={"/lps-school-sector-i/apply-now"} onClick={handleLinkClick}>Apply Now</Link></li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>

        <Card className={activeKey === "2" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="2">
              <Accordion.Header as="h4" onClick={() => handleToggle("2")}>
                Learning Pathways
                <span>{activeKey === "2" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li><Link to={"/learning-pathway-foundation"} onClick={handleLinkClick}>Foundational Year</Link></li>
                  <li><Link to={"/lps-school-sector-i/learning-pathway-preparatory"} onClick={handleLinkClick}>Preparatory, Middle & Secondary Years</Link></li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>

        <Card className={activeKey === "3" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="3">
              <Accordion.Header as="h4" onClick={() => handleToggle("3")}>
                Academics
                <span>{activeKey === "3" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li><Link to={"/lps-school-sector-i/academic-ethos"} onClick={handleLinkClick}>Academic Ethos</Link></li>
                  <li><Link to={"/lps-school-sector-i/pre-primary"} onClick={handleLinkClick}>Pre-Primary</Link></li>
                  <li><Link to={"/lps-school-sector-i/primary"} onClick={handleLinkClick}>Primary</Link></li>
                  <li><Link to={"/lps-school-sector-i/junior"} onClick={handleLinkClick}>Junior</Link></li>
                  <li><Link to={"/lps-school-sector-i/senior"} onClick={handleLinkClick}>Senior</Link></li>
                  <li><Link to={"/lps-school-sector-i/academic-department"} onClick={handleLinkClick}>Academic Department</Link></li>
                  <li><Link to={"/lps-school-sector-i/the-libraries"} onClick={handleLinkClick}>The Library</Link></li>
                  <li><Link to={"/lps-school-sector-i/career"} onClick={handleLinkClick}>Career</Link></li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>

        <Card className={activeKey === "4" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="4">
              <Accordion.Header as="h4" onClick={() => handleToggle("4")}>
                Pastoral
                <span>{activeKey === "4" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li><Link to={"/learning-support"} onClick={handleLinkClick}>Learning Support</Link></li>
                  <li><Link to={"/medical-support"} onClick={handleLinkClick}>Medical Support</Link></li>
                  <li><Link to={"/safeguarding"} onClick={handleLinkClick}>Safeguarding</Link></li>
                  <li><Link to={"/refectory"} onClick={handleLinkClick}>Refectory</Link></li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>

        <Card className={activeKey === "5" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="5">
              <Accordion.Header as="h4" onClick={() => handleToggle("5")}>
                Beyond The Classroom
                <span>{activeKey === "5" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li><Link to={"/making-a-difference"} onClick={handleLinkClick}>Making A Difference</Link></li>
                  <li><Link to={"/sport"} onClick={handleLinkClick}>Sport</Link></li>
                  <li><Link to={"/drama"} onClick={handleLinkClick}>Drama</Link></li>
                  <li><Link to={"/music"} onClick={handleLinkClick}>Music</Link></li>
                  <li><Link to={"/adventure"} onClick={handleLinkClick}>Adventure</Link></li>
                  <li><Link to={"/service"} onClick={handleLinkClick}>Service</Link></li>
                  <li><Link to={"/activities-week"} onClick={handleLinkClick}>Activities Week</Link></li>
                  <li><Link to={"/societies"} onClick={handleLinkClick}>Societies</Link></li>
                  <li><Link to={"/leadership"} onClick={handleLinkClick}>Leadership</Link></li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>

        <Card className={activeKey === "6" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="6">
              <Accordion.Header as="h4" onClick={() => handleToggle("6")}>
                Community
                <span>{activeKey === "6" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li><Link to={"/student"} onClick={handleLinkClick}>Student</Link></li>
                  <li><Link to={"/teacher"} onClick={handleLinkClick}>Teacher</Link></li>
                  <li><Link to={"/parents"} onClick={handleLinkClick}>Parents</Link></li>
                  <li><Link to={"/alumni"} onClick={handleLinkClick}>Alumni</Link></li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>

        <Card className={activeKey === "7" ? "active" : ""}>
          <Card.Header>
            <Accordion.Item eventKey="7">
              <Accordion.Header as="h4" onClick={() => handleToggle("7")}>
                Resources
                <span>{activeKey === "7" ? "−" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li><Link to={"/blog"} onClick={handleLinkClick}>Blog</Link></li>
                  <li><Link to={"/news"} onClick={handleLinkClick}>News</Link></li>
                  <li><Link to={"/stories"} onClick={handleLinkClick}>Stories</Link></li>
                  {/* <li><Link to={"/calendar"} onClick={handleLinkClick}>Calender</Link></li> */}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Card.Header>
        </Card>
      </Accordion>
    </>
  )
}
